import React from "react";
import PropTypes from "prop-types";
import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";

function ServiceImagesSection({
  images,
  uploadImages,
  replaceInputRef,
  replaceImage,
  handleReplaceImageClick,
  deleteImage,
}) {
  return (
    <div className="bg-white rounded-2xl shadow p-5 space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h3 className="text-lg font-semibold">Images</h3>
          <p className="text-sm text-gray-500">
            Upload, replace, or delete service images.
          </p>
        </div>

        <label className="inline-flex items-center gap-2 rounded-lg border border-sky-200 bg-sky-50 px-3 py-2 text-sm font-semibold text-sky-700 transition hover:bg-sky-100 cursor-pointer">
          <FaPlus />
          Upload Images
          <input
            type="file"
            multiple
            accept="image/*"
            onChange={uploadImages}
            className="hidden"
          />
        </label>
      </div>

      <input
        ref={replaceInputRef}
        type="file"
        accept="image/*"
        onChange={replaceImage}
        className="hidden"
      />

      {images.length === 0 ? (
        <div className="rounded-xl border border-dashed border-gray-300 p-8 text-center text-gray-400">
          No images uploaded yet.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {images.map((img) => (
            <div
              key={img.id}
              className="overflow-hidden rounded-xl border bg-gray-50"
            >
              <div className="group relative">
                <img
                  src={img.url}
                  loading="lazy"
                  alt=""
                  className="h-40 w-full object-cover transition duration-300 group-hover:scale-105"
                  onClick={() => window.open(img.url, "_blank")}
                />
                <div className="absolute bottom-2 left-2 text-xs font-semibold text-white">
                  Click to view
                </div>
              </div>
              <div className="flex items-center justify-between gap-2 border-t bg-white px-3 py-2">
                <button
                  type="button"
                  className="inline-flex items-center gap-2 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-700 transition hover:bg-amber-100"
                  onClick={() => handleReplaceImageClick(img.id)}
                >
                  <FaEdit />
                  Edit
                </button>
                <button
                  type="button"
                  className="inline-flex items-center gap-2 rounded-full border border-rose-200 bg-rose-50 px-2.5 py-1 text-xs font-semibold text-rose-700 transition hover:bg-rose-100"
                  onClick={() => deleteImage(img.id)}
                >
                  <FaTrash />
                  Remove
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

ServiceImagesSection.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      url: PropTypes.string,
    })
  ).isRequired,
  uploadImages: PropTypes.func.isRequired,
  replaceInputRef: PropTypes.shape({
    current: PropTypes.any,
  }).isRequired,
  replaceImage: PropTypes.func.isRequired,
  handleReplaceImageClick: PropTypes.func.isRequired,
  deleteImage: PropTypes.func.isRequired,
};

export default ServiceImagesSection;
